import { useEffect, useState } from 'react'

function useLocalStorageState(key, defaultValue) {
    // Get initial state from localStorage if it exists, otherwise use defaultValue
    const [state, setState] = useState(() => {
      const storedValue = localStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : defaultValue;
    });
  
    // Update localStorage whenever state changes
    useEffect(() => {
      localStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);
  
    return [state, setState];
}

export default useLocalStorageState;